module.exports = __webpack_public_path__ + "img/ref-naturel-1.470081f.jpg";